var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAboundMarkRight = function SvgAboundMarkRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 5.25386,
    height: 8.62097,
    viewBox: "0 0 5.25386 8.62097",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25386 8.62097L2.6751 7.77394L1.90335 7.44453L1.63983 7.33159C1.26336 7.1716 0.896313 7.02101 0.576321 6.75749C0.51044 6.70102 0.444559 6.63514 0.397502 6.56926C0.133978 6.24927 0.0210398 5.82575 0.00221676 5.37399C-0.0166063 4.82812 0.0869202 4.25402 0.218682 3.75521L1.38571 0H2.09158L5.24445 8.62097H5.25386Z",
    fill: "url(#paint0_linear_0_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5",
    x1: 3.21665,
    y1: 0.13357,
    x2: -2.38514,
    y2: 6.48951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAboundMarkRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/abound-mark-right.2824324fc0471711ab5b97117403fa62.svg";